"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFunctionBusTypeSchema = exports.ComponentFunctionBusType = void 0;
const zod_1 = require("zod");
var ComponentFunctionBusType;
(function (ComponentFunctionBusType) {
    ComponentFunctionBusType["Common"] = "common";
    ComponentFunctionBusType["SCSP"] = "scsp";
    ComponentFunctionBusType["SCMP"] = "scmp";
    ComponentFunctionBusType["MCSP"] = "mcsp";
    ComponentFunctionBusType["MCMP"] = "mcmp";
})(ComponentFunctionBusType || (exports.ComponentFunctionBusType = ComponentFunctionBusType = {}));
exports.ComponentFunctionBusTypeSchema = zod_1.z.nativeEnum(ComponentFunctionBusType);
//# sourceMappingURL=ComponentFunctionBusType.js.map